import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import form from '@/mixins/crud-form';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'PAY_TYPE_DETAIL',
        create: 'PAY_TYPE_CREATE',
        update: 'PAY_TYPE_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [].concat(_toConsumableArray(this.mode === 'create' ? [{
        prop: 'pay_type',
        default: '',
        label: 'pay_type',
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.pay_type,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "pay_type", $$v);
              }
            }
          });
        }
      }] : []), [{
        prop: 'name',
        default: '',
        label: 'name',
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.name,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "name", $$v);
              }
            }
          });
        }
      }, {
        prop: 'icon_url',
        default: '',
        label: 'icon_url',
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this.form.model.icon_url,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "icon_url", $$v);
              }
            }
          });
        }
      }, {
        prop: 'json_set',
        default: '',
        label: 'json_set',
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "type": "textarea",
              "autosize": true,
              "clearable": true
            },
            "model": {
              value: _this.form.model.json_set,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "json_set", $$v);
              }
            }
          });
        }
      }]);
    }
  },
  methods: {}
};